import { OpenAPI as LifeOpenAPI } from '@festina/life-general-types/life'
import { dateUtils } from '@festina-life/core'
import cx from 'classnames'
import type { HtmlHTMLAttributes } from 'react'

import { useFetchComponentVersion } from '../../hooks/useFetchComponentVersion'

export type BuildNoProps = HtmlHTMLAttributes<HTMLDivElement> & {
  buildNo: string
  buildTime?: string
  className?: string
}

export const BuildInfo = ({ buildNo, buildTime, className }: BuildNoProps) => {
  const { data: backendVersion } = useFetchComponentVersion(
    {},
    {
      enabled: !!LifeOpenAPI.BASE,
      throwOnError: false,
      retry: false, // Not critical to have this information
    },
  )

  return (
    <div
      className={cx(
        'fixed bottom-0 right-0 flex gap-2 text-sm opacity-60',
        className,
      )}
    >
      <span>
        {buildNo} / {backendVersion}
      </span>
      {buildTime && (
        <span>{dateUtils.dateWithTimeAsStr(new Date(buildTime))}</span>
      )}
    </div>
  )
}
